import {useSelector} from "react-redux";
import {selectUserPresence} from "joynt/state/selectors/joint";

export function useUserPresence(id) {
    return useSelector(s=>selectUserPresence(s, id));
}